export default __webpack_public_path__ + "7dfd926426db48df575f54c7bcf2d4a2.png";